/** Dígitos internacionales para wa.me (sin +). null si el teléfono no es usable. */
export function whatsappE164DigitsFromTelefono(raw) {
  if (raw == null || raw === '') return null;
  let s = String(raw).replace(/[\s().-]/g, '');
  if (!s) return null;
  if (s.startsWith('00')) s = s.slice(2);
  if (s.startsWith('+')) s = s.slice(1);
  // Móvil/fijo español sin prefijo (9 dígitos)
  if (/^\d{9}$/.test(s) && s[0] !== '0') s = `34${s}`;
  if (!/^\d{10,15}$/.test(s)) return null;
  return s;
}

/**
 * Abre WhatsApp con el mensaje ya escrito. Con teléfono válido, abre ese chat.
 * `api.whatsapp.com/send` y no `wa.me`: la redirección de wa.me sustituye los
 * emoji (UTF-8 de 4 bytes) por U+FFFD, el rombo con interrogación.
 */
export function openWhatsappChat(telefono, message) {
  const digits = whatsappE164DigitsFromTelefono(telefono);
  const encoded = encodeURIComponent(message ?? '');
  const href = digits
    ? `https://api.whatsapp.com/send?phone=${digits}&text=${encoded}`
    : `https://api.whatsapp.com/send?text=${encoded}`;
  window.open(href, '_blank', 'noopener,noreferrer');
}
